export function getEffectProps(props) {
    var _a;
    var classes = (_a = {
            '__disabled': props.disabled === true,
            'focus-effect': props.focusEffect === true,
            'active': props.activeEffect === true,
            'hover': props.hoverEffect === true,
            'actived': props.activedEffect === true,
            'fade-in-fast': props.fadeInFast === true,
            'fade-in': props.fadeIn === true,
            'fade-out-fast': props.fadeOutFast === true,
            'fade-out': props.fadeOut === true
        },
        _a[props.effect] = typeof props.effect === 'string',
        _a);
    return {
        classes: classes,
        props: {},
        styles: {},
        variables: {}
    };
}
